export const getEuroCentToEuro = (euroCents) => {
  // Ensure the input is treated as a number
  const euros = (euroCents / 100).toFixed(2); // Divide by 100 and ensure two decimal places
  return `${euros.replace(".", ",")}€`; // Replace the decimal point with a comma and add the euro symbol
};
